import { Injectable } from "@angular/core";
import { NbAuthStrategyClass, NbOAuth2AuthStrategyOptions, NbPasswordAuthStrategy,NbPasswordAuthStrategyOptions } from '@nebular/auth';
@Injectable()
export class spidStrategie extends NbPasswordAuthStrategy {
  static setup(options: NbPasswordAuthStrategyOptions): [NbAuthStrategyClass, NbPasswordAuthStrategyOptions] {
    return [spidStrategie, options]; // HERE we make sure our strategy reutrn correct class reference
  }
}